<div [ngStyle]="contentStyle" class="section password-change pointer-events-none">
  <p *ngIf="dataIn?.attri?.widgetProperties?.subHeadingLabel" [ngStyle]="mergedHeadingStyle">
    {{ dataIn?.attri?.widgetProperties?.subHeadingLabel }}
  </p>
  <div class="text-left">
    <form class="beneficiary-form" [formGroup]="passwordForm">
      <div [ngStyle]="inputContentStyle">
        <finxone-input
          [type]="fieldType"
          [name]="'currentPassword'"
          (change)="onSubmit(true)"
          [label]="dataIn?.attri?.widgetProperties['passFieldLabel']"
          formControlName="currentPassword"
          [formControlInvalid]="
            !!(
              passwordForm.controls['currentPassword']?.dirty &&
              passwordForm.controls['currentPassword']?.invalid &&
              passwordForm.controls['currentPassword']?.touched
            )
          "
          [value]="passwordForm.controls['currentPassword']?.value ?? ''"
          [validationConfig]="[
            {
              type: 'required',
              message: 'Field is mandatory'
            }
          ]"
        >
          <span suffix #suffix class="password-field-icons">
            <mat-icon
              *ngIf="
                fieldType === 'password' && (passwordFieldConfigs?.cssConfig?.showPasswordIconVisible ?? true)
              "
              (click)="changeFieldType(fieldType)"
              [svgIcon]="passwordFieldConfigs?.cssConfig?.showPasswordIcon ?? 'pass-eye'"
            ></mat-icon>
            <mat-icon
              *ngIf="
                fieldType === 'text' && (passwordFieldConfigs?.cssConfig?.showPasswordIconVisible ?? true)
              "
              (click)="changeFieldType(fieldType)"
              [svgIcon]="passwordFieldConfigs?.cssConfig?.hidePasswordIcon ?? 'pass-eye-hide'"
            ></mat-icon>
          </span>
        </finxone-input>
      </div>
    </form>
  </div>
</div>
